import _ from "lodash"

import { HTTP_METHODS } from "./../../../../../constants"
import { makeExternalCall } from "./../../../../../helpers"
import { isRLTLang } from "../../../../../i18n"


const FETCH_OPTIONS_ENDPOINT = "/api/pa/options/list?list_number=11"

const formatOptions = (options) => options.map((option) => (
  { label: isRLTLang() ? option.valueAr : option.valueFr, value: option.rank }))


export const lifeSkillsLevelUIHelper = (callback, keyword) => {

  let endpoint = FETCH_OPTIONS_ENDPOINT
  let query = {}
  if (!_.isEmpty(keyword)) {
    query = { q: keyword }
  }

  return new Promise((resolve, reject) =>
    makeExternalCall(HTTP_METHODS.GET, endpoint, {}, {}, query)
      .then(resp => {
        let result = {}
        if (_.isPlainObject(resp.data)) {
          result = [resp.data]
        } else {
          result = resp.data
        }
        resolve(callback(formatOptions(result)))
      })
      .catch(err => reject(err.response))
  )
    }




    const formatSkillLevelsOptions = (options) => {
      let values = {}
      options.forEach((option) => {
          values[option.rank] = isRLTLang() ? option.valueAr : option.valueFr
      })
      return values;
  }
  
  
  export const getSkillLevelsOptions = (callback, keyword) => {

    let endpoint = FETCH_OPTIONS_ENDPOINT
    let query = {}
    if (!_.isEmpty(keyword)) {
      query = { q: keyword }
    }
  
    return new Promise((resolve, reject) =>
      makeExternalCall(HTTP_METHODS.GET, endpoint, {}, {}, query)
        .then(resp => {
          let result = {}
          if (_.isPlainObject(resp.data)) {
            result = [resp.data]
          } else {
            result = resp.data
          }
          resolve(callback(formatSkillLevelsOptions(result)))
        })
        .catch(err => reject(err.response))
    )
      }




/* export const LIFE_SKILLS_LEVEL = { 
    1: "niveau compétence 1",
    2: "niveau compétence 2",
    3: "niveau compétence 3",

  }
  
  
  export const lifeSkillsLevelUIHelper = (intl) =>
    Object.keys(LIFE_SKILLS_LEVEL).map((key) => ({
      value: parseInt(key),
      label: intl.formatMessage({ id: LIFE_SKILLS_LEVEL[key] }),
    })) */